import { render } from "./FiscalizacaoPessoaJuridica.vue?vue&type=template&id=00981704"
import script from "./FiscalizacaoPessoaJuridica.vue?vue&type=script&lang=js"
export * from "./FiscalizacaoPessoaJuridica.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__